// extracted by mini-css-extract-plugin
export var active = "_1d-d";
export var blink = "_1d-e";
export var container = "_1d-5";
export var controls = "_1d-0";
export var controlsRight = "_1d-1";
export var fakeCursor = "_1d-c";
export var hidden = "_1d-b";
export var quillContainerSmall = "_1d-7";
export var quillEditor = "_1d-6";
export var quillEditorSmall = "_1d-8";
export var quillFormatButtons = "_1d-a";
export var quillToolbar = "_1d-9";
export var removePadding = "_1d-2";
export var state = "_1d-3";
export var stateTitle = "_1d-4";